module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"current":"stávající"},"de":{"current":"aktuell"},"es":{"current":"actual"},"fr":{"current":"actuel"},"id":{"current":"Sekarang ini"},"it":{"current":"attuale"},"ja":{"current":"現在"},"sw":{"current":"sasa"}}')
  delete Component.options._Ctor
}
